// BidHistory.js
import React, { useCallback, useEffect, useState } from "react";
import "./BidHistory.css";
import {useDispatch } from "react-redux";
import { getCharts } from "../features/userSlice";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useT } from "../i18n";

const ChartCompo = () => {
    const {chart_ype,gameName}=useParams();
    const dispatch=useDispatch();
    const { t } = useT();
    const [dataWeek_jodi,setdataWeek_jodi]=useState([]);
     
    // const dataWeek_jodi=[{mon:'11',tue:'12',wed:'13',thu:'14',fri:'15',sat:'16',sun:'17'},{mon:'11',tue:'12',wed:'13',thu:'14',fri:'15',sat:'16',sun:'17'},{mon:'11',tue:'12',wed:'13',thu:'14',fri:'15',sat:'16',sun:'17'},{mon:'11',tue:'12',wed:'13',thu:'14',fri:'15',sat:'16',sun:'17'}]

    
    const  sumOfDigits=(number)=> {
      if( number ){
      return number
        .toString() // Convert number to string
        .split("") // Split string into individual digits
        .map(Number) // Convert each character back to a number
        .reduce((acc, digit) => acc + digit, 0) % 10 || '0'; // Sum up the digits
      }else{
        return '*';
      }
    }

    
    const fetchData = useCallback(async () => {
      try {
        let dataSet = new FormData();
        dataSet.append('game_name',gameName.split('_').join(' '));
        dataSet.append('type',chart_ype);
        const result =  await dispatch(getCharts(dataSet)).unwrap();
        if(result.success){
          setdataWeek_jodi(result.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } 
    }, [chart_ype, dispatch, gameName]);

  useEffect (()=>{
       
        fetchData()
     
     },[fetchData])

     
     
     

  const days = ['mon','tue','wed','thu','fri','sat','sun'];
  const isJodi = chart_ype==='jodi_chart';
  const scrollToEnd = () => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="chr-screen">
      <div className="chr-head">
        <div>
          <h2>{gameName.split('_').join(' ')}</h2>
          <p>{isJodi ? t('Jodi Chart') : t('Pana Chart')}</p>
        </div>
        <button type="button" className="chr-jump" onClick={scrollToEnd}><FontAwesomeIcon icon={faArrowDown} /> {t('Bottom')}</button>
      </div>

      <div className="chr-card">
        <table className={`chr-table${isJodi ? '' : ' pana'}`}>
          <thead>
            <tr>
              <th>{t('Date')}</th>
              {days.map((day) => <th key={day}>{t(day.charAt(0).toUpperCase()+day.slice(1))}</th>)}
            </tr>
          </thead>
          <tbody>
            {dataWeek_jodi?.map((bid, index) => (
              <tr key={index}>
                <td className="chr-date">{bid.date ? bid.date.split('-').map((part, i) => <span key={i}>{part}</span>) : '**'}</td>
                {days.map((day) => isJodi ? (
                  <td key={day} className={bid[day] ? '' : 'chr-empty'}>{bid[day] || '**'}</td>
                ) : (
                  <td key={day}>
                    <div className="chr-pana">
                      <span>{bid[day]?.open_panna}</span>
                      <strong>{`${sumOfDigits(bid[day]?.open_panna)}${sumOfDigits(bid[day]?.close_panna)}`}</strong>
                      <span>{bid[day]?.close_panna}</span>
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button type="button" className="chr-jump chr-top" onClick={scrollToTop}><FontAwesomeIcon icon={faArrowUp} /> {t('Back to top')}</button>
    </div>
  );
};

export default ChartCompo;
